module.exports = __webpack_public_path__ + "assets/be168547d52e039c27e95e45fbc8507b.mp3";